class ObserveIntersection {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.observeable = this.DOM.el.dataset.intersectionObserve;
        this.DOM.targets = Array.from(document.querySelectorAll(this.DOM.observeable));

        this.observerBeforeClass = this.DOM.el.dataset.observerBeforeClass || 'is-before';
        this.observerAfterClass = this.DOM.el.dataset.observerAfterClass || 'is-after';
        this.observerActiveClass = this.DOM.el.dataset.observerActiveClass || 'is-active';

        this.initEvents();
    }
    initEvents() {
        let observer;
        observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.boundingClientRect.bottom < 0) {
                    // After
                    this.removeClass(this.DOM.el, this.observerBeforeClass);
                    this.removeClass(this.DOM.el, this.observerActiveClass);
                    this.addClass(this.DOM.el, this.observerAfterClass);
                } else if (entry.boundingClientRect.top > window.innerHeight) {
                    // Before
                    this.removeClass(this.DOM.el, this.observerAfterClass);
                    this.removeClass(this.DOM.el, this.observerActiveClass);
                    this.addClass(this.DOM.el, this.observerBeforeClass);
                } else {
                    // Active
                    this.removeClass(this.DOM.el, this.observerBeforeClass);
                    this.removeClass(this.DOM.el, this.observerAfterClass);
                    this.addClass(this.DOM.el, this.observerActiveClass);
                }
            })
        });

        this.DOM.targets.forEach(target => {
            observer.observe(target);
        })
    }
    removeClass(element, className) {
        if (element.classList.contains(className)) element.classList.remove(className);
    }
    addClass(element, className) {
        if (!element.classList.contains(className)) element.classList.add(className);
    }
}

const observerElements = Array.from(document.querySelectorAll('[data-observe-intersection]'));
if (observerElements !== null) {
    observerElements.forEach((element) => new ObserveIntersection(element));
}
